type GraphemeSegment = { segment: string };

type GraphemeSegmenter = {
  segment: (input: string) => Iterable<GraphemeSegment>;
};

type IntlWithSegmenter = typeof Intl & {
  Segmenter?: new (
    locales?: string | string[],
    options?: { granularity: 'grapheme' },
  ) => GraphemeSegmenter;
};

function getSegmenter(): GraphemeSegmenter | null {
  if (typeof Intl === 'undefined') return null;
  const SegmenterCtor = (Intl as IntlWithSegmenter).Segmenter;
  if (typeof SegmenterCtor !== 'function') return null;
  return new SegmenterCtor(undefined, { granularity: 'grapheme' });
}

/** Visible character count (grapheme clusters), not UTF-16 code units. */
export function graphemeLength(value: string): number {
  const segmenter = getSegmenter();
  if (segmenter) {
    return [...segmenter.segment(value)].length;
  }
  return [...value].length;
}

/** Cut at a grapheme boundary so emoji/flags are not split. */
export function sliceGraphemes(value: string, max: number): string {
  if (max <= 0) return '';
  const segmenter = getSegmenter();
  const parts = segmenter
    ? [...segmenter.segment(value)].map((part) => part.segment)
    : [...value];
  if (parts.length <= max) return value;
  return parts.slice(0, max).join('');
}
